<template>
    <div v-if="fields">
        <div class="row">
            <div :class="columnClass ? columnClass : 'col-sm-12'" v-for="(field, index) in fields" :key="index">
                <div class="form-group" >
                    <template v-if="field.fieldtype == 'text' && field.fieldname.toLowerCase().includes('mobile')">
                        <label :for="safeFieldName(field.fieldname)">
                            {{ field.fieldname }}
                        </label>
                        <vue-tel-input
                            v-model="customfields[field.fieldid]"
                            :preferredCountries="['AU', 'US', 'GB', 'NZ']"
                            :mode="'international'"
                            />
                    </template>

                    <!-- dropdown input type -->
                    <template v-else-if="field.fieldtype == 'dropdown'">
                        <label :for="safeFieldName(field.fieldname)">{{ field.fieldname }}</label>
                        <b-form-select
                            :id="safeFieldName(field.fieldname)"
                            v-model="customfields[field.fieldid]"
                            :options="options[field.fieldid]"
                            :name="safeFieldName(field.fieldname)">
                        </b-form-select>
                    </template>


                    <template v-else-if="field.fieldtype == 'tickbox'">
                        <b-form-checkbox
                            :id="safeFieldName(field.fieldname)"
                            v-model="customfields[field.fieldid]"
                            :name="safeFieldName(field.fieldname)"
                            unchecked-value=""
                            value="on">
                            {{ field.fieldname }}
                        </b-form-checkbox>
                    </template>

                    
                    <template v-else-if="field.fieldtype == 'text' && safeFieldName(field.fieldname).toLowerCase().includes('monitoring-alert-email')">
                        <label :for="safeFieldName(field.fieldname)">{{ field.fieldname }}</label>
                        <div class="mma-alert-emails">
                            <b-form-tags 
                                :value="getMonitoringAlertEmailsValue(field)"
                                :tag-validator="tagValidator"
                                invalid-tag-text="Please enter a valid email address"
                                tag-class="overflow-auto"
                                no-outer-focus
                                class="mb-2 border-0 p-0"
                                @input="setMonitoringAlertEmails($event, field.fieldid)">
                                <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                                    <b-input-group class="mb-2">
                                        <b-form-input
                                            v-bind="inputAttrs"
                                            v-on="inputHandlers"
                                            type="email"
                                            placeholder="example@email.com.au"
                                            class="form-control"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button @click="addTag()" variant="primary" class="text-white">Add</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div class="d-inline-block" style="font-size: 1.5rem;">
                                    <b-form-tag
                                        v-for="tag in tags"
                                        @remove="removeTag(tag)"
                                        :key="tag"
                                        :title="tag"
                                        variant="light"
                                        class="mr-1 text-small"
                                    >{{ tag }}</b-form-tag>
                                    </div>
                                </template>
                            </b-form-tags>
                        </div>
                    </template>

                    <!-- text input types -->
                    <template v-else>
                        <label :for="safeFieldName(field.fieldname)">
                            {{ field.fieldname }}
                        </label>
                        <b-form-input
                            type="text"
                            :required="field.required"
                            :disabled="field.readonly"
                            :id="safeFieldName(field.fieldname)"
                            v-model="customfields[field.fieldid]"
                            :name="safeFieldName(field.fieldname)"
                            @blur="validateIfRequired(field)"
                        ></b-form-input>
                        <template v-if="failedValidations[field.fieldname.toLowerCase()]">
                            <p class="text-red text-sm">{{ failedValidations[field.fieldname.toLowerCase()] }}</p>
                        </template>
                    </template>

                    <div v-if="customfields[field.fieldid] && field.required != ''">
                        <small class="text-muted">* Required</small>
                    </div>
                    <div v-else>
                        <small class="text-muted">&nbsp;</small>
                    </div>
                    <!-- default message -->
                    <div v-show="customfields[field.fieldid]">&nbsp;</div><!-- valid message -->
                    <div v-if="!customfields[field.fieldid] && field.required != ''" class="invalid-feedback">* Required</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { VueTelInput } from 'vue-tel-input';

export default {
    props: ['fields', 'columnClass'],
    components: {
        VueTelInput,
    },
    data() {
        return {
            customfields:{},
            options:{},
            validateFields: ['abn'],
            failedValidations: {},
			rules: {
				email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			}
        }
    },
    created() {
        this.createFormObject();
    },
    methods: {
        /** Create form object for submission */
        createFormObject() {
            // this.fields.forEach(field => {
            _.forIn(this.fields, field => {
                switch(field.fieldtype) {
                    case 'text':
                        this.customfields[field.fieldid] = field.value;
                        break;
                    case 'tickbox':
                        this.customfields[field.fieldid] = field.value;
                        break;
                    case 'dropdown':
                        this.options[field.fieldid] = [];
                        /** Create the dropdown selections */
                        field.fieldoptions.split(',').forEach(option => {
                            this.options[field.fieldid].push({value: option, text: option});
                        });
                        /** Set default option */
                        this.customfields[field.fieldid] = this.options[field.fieldid].find(option => option.value == field.value).value;
                        break;
                }
            });
        },

        /** convert to lower case spaces to hyphens */
        safeFieldName(name) {
            return name.toLowerCase().replaceAll(' ','-');
        },

        hasValidation(field) {
            return this.validateFields.includes(field.fieldname.toLowerCase());
        },

        validateIfRequired(field) {
            if(! this.hasValidation(field)) return;
            const fieldname = field.fieldname.toLowerCase();
            const value = this.customfields[field.fieldid];
            
            axios.post(`/api/user-validation/${fieldname}`, { value: value })
                .then(() => {
                    const failedValidations = { ...this.failedValidations };
                    delete failedValidations[fieldname];
                    this.failedValidations = failedValidations;
                }).catch((error) => {
                    this.failedValidations = {...this.failedValidations, ...{ [fieldname]: error.response.data}}
                });
        },
        getMonitoringAlertEmailsValue(field) {
            return field.value.split(',');
        },
        setMonitoringAlertEmails(value, id) {
            this.customfields[id] = value.join(', ');
        },
		tagValidator(tag) {
			return this.rules.email.test(tag);
		}
    }
}
</script>


<style lang="scss" scoped>
.mma-alert-emails .b-form-tag > .b-form-tag-content.text-truncate {
	font-size: 14px;
	line-height: 130%;
}
.mma-alert-emails .b-form-tag > button.b-form-tag-remove {
	font-size: 16px;
	line-height: 130%;
    padding: 0 5px;
}
.b-form-tag {
    font-family: 'sau-roboto-light';
}
</style>